<template>
  <div class="header">
    <div class="header_mobile-container">
      <div class="header_mobile-logo">
        <a href="/">
          <img class="header_logo" src="@/assets/logo/logo.png" alt="logo" />
        </a>
      </div>
      <div class="header_mobile-wrapper">
        <div class="header_mobile-hamburger" v-on:click="showNav($data)"></div>
      </div>
    </div>

    <div class="header_desktop-container">
      <div class="header_left">
        <a href="/">
          <img class="header_logo" src="@/assets/logo/logo.png" alt="logo" />
        </a>
      </div>
      <div class="header_center">
        <div class="header_meum-list">
          <div class="header_meum-item">
            <span class="header_meum-item-label">首页</span>
          </div>
          <div class="header_meum-item">
            <span class="header_meum-item-label">新闻动态</span>
          </div>
          <div class="header_meum-item">
            <span class="header_meum-item-label">使用说明</span>
          </div>
          <div class="header_meum-item" @click="goControl">
            <span class="header_meum-item-label">控制台</span>
          </div>
          <div class="header_meum-item" @click="goDevelopers">
            <span class="header_meum-item-label">企业开发</span>
          </div>
        </div>
      </div>
      <div class="header_right">
        <div class="header_right-menu-list">
          <div class="header_right-login header_right-menu-item">
            <span @click="goLogin" class="header_meum-item-label">登录</span>
            /
            <span @click="goRegister" class="header_meum-item-label">注册</span>
          </div>
        </div>
      </div>
    </div>

    <!-- header mobile-->
    <div ref="mgn" class="mobile-global-navigation">
      <div ref="items" class="mobile-global-navigation__left-container">
        <div class="mobile-global-navigation__menu-item">
          <div
            ref="item1"
            v-on:click="goLogin"
            class="mobile-global-navigation__menu-item-label js-mobile-menu-item mobile-global-navigation__menu-item-label--active"
            data-menu-id="1"
          >
            首页
          </div>
        </div>
        <!-- <div class="mobile-global-navigation__menu-item">
          <div
            ref="item4"
            v-on:click="selectNav($event)"
            class="mobile-global-navigation__menu-item-label js-mobile-menu-item"
            data-menu-id="4"
          >
            使用说明
          </div>
        </div> -->
        <div class="mobile-global-navigation__menu-item">
          <div
            ref="item2"
            v-on:click="goControl($event)"
            class="mobile-global-navigation__menu-item-label js-mobile-menu-item"
            data-menu-id="2"
          >
            控制台
          </div>
        </div>
        <div class="mobile-global-navigation__menu-item">
          <div
            ref="item3"
            v-on:click="goDevelopers($event)"
            class="mobile-global-navigation__menu-item-label js-mobile-menu-item"
            data-menu-id="3"
          >
            企业开发
          </div>
        </div>
      </div>

      <div class="mobile-global-navigation__right-container">
        <div class="mobile-global-navigation__right-header-container">
          <div
            class="mobile-global-navigation__right-header-menu-item js-account-link hidden"
          >
            您好，<span class="account-link__username"></span>
          </div>
          <!-- <div class="js-login-link">
            <a class="mobile-global-navigation__right-header-menu-item" href=""
              >登录</a
            >
          </div> -->
          <div class="mobile-global-navigation__right-header-wrapper">
            <div
              v-on:click="closeNav($data)"
              class="mobile-global-navigation__right-header-menu-item js-close-button"
            >
              <img
                class="mobile-global-navigation__close-btn"
                src="https://www.mercedes-benz.com.cn/etc/designs/mb-cn/images/close.svg"
                width="15"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- header mobile end-->
  </div>
</template>

<script>
export default {
  components: {},
  data: function() {
    return {
      //搜索栏默认隐藏
      isShow: false
    };
  },
  created() {},
  methods: {
    goControl() {
      if (window.localStorage.getItem("user")) {
        this.$router.push("/console");
      } else {
        this.$router.push("/login");
      }
    },
    goDevelopers() {
      if (window.localStorage.getItem("user")) {
        this.$router.push("/developers");
      } else {
        this.$router.push("/login");
      }
    },
    goLogin() {
      this.$router.push("/login");
    },
    goRegister() {
      this.$router.push("/register");
    },
    //桌面端搜索栏显示与隐藏
    search() {
      this.isShow = !this.isShow;
    },
    //移动端点击打开折叠菜单
    showNav($data) {
      this.$refs.mgn.style.display = "flex";
    },
    //移动端点击关闭折叠菜单
    closeNav($data) {
      this.$refs.mgn.style.display = "none";
    },
    //点击切换nav
    selectNav($event) {
      //获取左边nav dom节点
      var items = this.$refs.items.children;
      //获取右边nav dom节点
      var lists = this.$refs.lists.children;

      for (var i = 0; i < items.length; i++) {
        //console.log(lists[i]);
        //循环遍历 隐藏样式
        items[i].firstChild.className =
          "mobile-global-navigation__menu-item-label js-mobile-menu-item";
        lists[i].className = "mobile-global-navigation__right-menu-list";
      }
      //点击区域的背景变白色
      $event.currentTarget.className =
        "mobile-global-navigation__menu-item-label js-mobile-menu-item mobile-global-navigation__menu-item-label--active";
      //条件判断显示右边对应div
      if ($event.currentTarget == this.$refs.item1) {
        lists[0].className =
          "mobile-global-navigation__right-menu-list mobile-global-navigation__right-menu-list--active js-child-menu-1";
      } else if ($event.currentTarget == this.$refs.item2) {
        lists[1].className =
          "mobile-global-navigation__right-menu-list mobile-global-navigation__right-menu-list--active js-child-menu-2";
      } else if ($event.currentTarget == this.$refs.item3) {
        lists[2].className =
          "mobile-global-navigation__right-menu-list mobile-global-navigation__right-menu-list--active js-child-menu-3";
      } else {
        lists[3].className =
          "mobile-global-navigation__right-menu-list mobile-global-navigation__right-menu-list--active js-child-menu-4";
      }
    },
    //移动端搜索栏显示与隐藏
    showSearchBar($event) {
      var searches = this.$refs.searches;
      if (searches.className == "mobile-global-navigation__search-container") {
        searches.className =
          "mobile-global-navigation__search-container mobile-global-navigation__search-container--active";
      } else {
        searches.className = "mobile-global-navigation__search-container";
      }
    }
  }
};
</script>

<style>
.header_mobile-container {
  width: 100%;
  -ms-flex-pack: justify;
  justify-content: space-between;
  min-height: 64px;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 20px;
}

.header_mobile-container .header_mobile-logo {
  float: left;
  width: 162px;
  height: 40px;
  margin: 12px auto;
}

.header_mobile-wrapper {
  width: 120px;
  height: 20px;
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
  float: right;
}

.header_mobile-car {
  margin-right: 38px;
}

.header_mobile-hamburger {
  width: 28px;
  height: 28px;
  background-image: url(../img/zhedie.png);
  background-size: 100%;
  background-repeat: no-repeat;
  margin-right: 40px;
}

.header {
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 552;
  width: 100%;
  position: fixed;
  margin: 0;
}

.header_desktop-container {
  padding: 20px 7% 0px 7%;
  height: 90px;
  margin: 0 auto;
  -ms-flex-pack: justify;
  justify-content: space-between;
  z-index: 1000;
}

.header_left {
  float: left;
  display: flex;
  -ms-flex-align: end;
  align-items: flex-end;
  -ms-flex-pack: start;
  justify-content: flex-start;
  padding-bottom: 20px;
}

.header_left a {
  text-decoration: none;
}

.header_center {
  margin: 0 50px;
  width: 610px;
  /* height: 90px; */
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.header_meum-list {
  width: 610px;
  height: 39px;
  display: flex;
}

.header_meum-item {
  text-align: center;
  width: 64px;
  height: 16px;
  margin: 0 32px 0 26px;
  font: normal 500 16px/1 "PingFang SC", "Hiragino Sans GB", "Noto Sans CJK SC",
    "Source Han Sans SC", "Microsoft YaHei", "SimHei", Helvetica, Arial, serif;
  padding-bottom: 20px;
  color: #d8d8d8;
  white-space: nowrap;
  border-bottom: 3px solid transparent;
}

.global-header__sub-menu-item--filter {
  padding-right: 0;
  right: 7%;
  position: absolute;
}

.header_meum-item-label {
  cursor: pointer;
  display: inline-block;
}

.header_sub-menu-container {
  position: absolute;
  top: 110px;
  left: 0;
  z-index: 2;
  display: none;
  width: 100%;
  background-color: #1f1f1f;
}

.header_sub-menu-list {
  display: flex;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  -ms-flex-align: center;
  align-items: center;
  max-width: 1280px;
  margin: 0 auto;
}

.header_sub-menu-list-all-vehicles {
  max-width: calc(100vw - 400px);
}

.header_sub-menu-item {
  font: normal 500 14px/22px "PingFang SC", "Hiragino Sans GB",
    "Noto Sans CJK SC", "Source Han Sans SC", "Microsoft YaHei", "SimHei",
    Helvetica, Arial, serif;
  padding: 24px 0px;
  color: #666;
  display: inline-block;
  list-style-type: none;
}

.header_sub-menu-item {
  padding: 24px calc(50 / 1440 * 100vw);
  padding-right: calc(3.47222vw);
}

.header_sub-menu-item a {
  color: #fff;
  text-decoration: none;
}

.header_sub-menu-item a:hover {
  /* color: rgb(75, 171, 233); */
  color: #409eff;
}

.header_meum-item:hover .header_sub-menu-container {
  display: block;
}

.header_meum-item:hover {
  border-width: 0 0 5px 0;
  border-style: solid;
  border-color: #409eff;
}

.header_sub-menu-container:hover {
  display: block;
}

.header_right {
  width: 92px;
  height: 90px;
  float: left;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: end;
  align-items: center;
  -ms-flex-pack: end;
  justify-content: flex-end;
  z-index: 1000;
}

.header_right-menu-list {
  width: 92px;
  height: 43px;
  display: flex;
}

.header_right-menu-item {
  font: normal 500 14px/22px "PingFang SC", "Hiragino Sans GB",
    "Noto Sans CJK SC", "Source Han Sans SC", "Microsoft YaHei", "SimHei",
    Helvetica, Arial, serif;
  color: #fff;
  padding: 0 0 20px 8px;
  white-space: nowrap;
}

.header_right-search {
  display: inline-block;
  vertical-align: text-top;
}

.icon-search-bold {
  font-size: 16px;
  cursor: pointer;
}

.icon-search-bold img {
  width: 12px;
  height: 15px;
  font-size: 16px;
  cursor: pointer;
}

.header_sub-menu-container {
  position: absolute;
  top: 110px;
  left: 0;
  z-index: 2;
  width: 100%;
  display: none;
  background-color: #1f1f1f;
}

.header_sub-menu-container-center {
}

.header_sub-menu-container-active {
  display: block;
}

.header_right-menu-item-login {
  cursor: pointer;
}

.header_right-menu-item-login:hover {
  color: #409eff;
}

.header_search-container {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 20px 0px;
}

.header_search-wrapper {
  border-bottom: 1px solid rgba(216, 216, 216, 0.1);
  padding-bottom: 5px;
  max-width: 620px;
  width: 100%;
  position: relative;
}

.header_search-input {
  background-color: #1f1f1f;
  border: 0;
  padding-left: 1px;
  width: 100%;
  color: #fff;
  font: normal 500 16px/24px "PingFang SC", "Hiragino Sans GB",
    "Noto Sans CJK SC", "Source Han Sans SC", "Microsoft YaHei", "SimHei",
    Helvetica, Arial, serif;
}

.header_search-btn {
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  background: none;
  line-height: normal;
}

.header_right-logout {
}

.hidden {
  display: none !important;
}

.global-header__sub-menu-item--filter a {
  display: -ms-flexbox;
  display: flex;
}

.global-header__sub-menu-item-filter-icon {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  margin-right: 10px;
}

.global-header__sub-menu-item-filter-icon-before {
  display: block;
}

.global-header__sub-menu-item-filter-icon-after {
  display: none;
}

@media screen and (min-width: 1200px) {
  .header_mobile-container {
    display: none;
  }

  .header_desktop-container {
    display: flex;
  }

  .header_logo {
    max-width: 283px;
    height: 64px;
    width: auto;
    display: inline-block;
    vertical-align: bottom;
  }

  .header_right-menu-item-login {
    margin-left: 32px;
    color: #fff;
  }
}

.mobile-global-navigation--active {
  display: -ms-flexbox;
  display: flex;
}

.mobile-global-navigation {
  position: fixed;
  top: 0;
  height: 100%;
  background-color: #fff;
  width: 100%;
  z-index: 9999;
  display: none;
}

.mobile-global-navigation__left-container {
  width: 124px;
  background-color: #000000;
  padding-top: 90px;
}

.mobile-global-navigation__right-container {
  width: calc(100% - 124px);
  overflow-x: hidden;
  overflow-y: auto;
}
.mobile-global-navigation__right-content-container {
  padding-left: 32px;
  padding-right: 20px;
  padding-top: 28px;
}

.mobile-global-navigation__menu-item {
  color: #fff;
  font: normal 500 16px/23px "PingFang SC", "Hiragino Sans GB",
    "Noto Sans CJK SC", "Source Han Sans SC", "Microsoft YaHei", "SimHei",
    Helvetica, Arial, serif;
  padding: 12px 0px;
  text-align: center;
}

.mobile-global-navigation__menu-item-label--active {
  color: #333;
  background-color: #fff;
}

.mobile-global-navigation__menu-item-label {
  padding: 20px 0px;
}

.mobile-global-navigation__right-header-container {
  display: -ms-flexbox;
  display: flex;
  padding: 32px 20px 16px 32px;
  -ms-flex-pack: justify;
  justify-content: flex-end;
  overflow-x: auto;
}

.mobile-global-navigation__right-header-menu-item:first-child {
  margin-left: 0px;
}

.hidden {
  display: none !important;
}

.hidden {
  display: none !important;
}

.hidden {
  display: none;
}

.mobile-global-navigation__right-header-menu-item {
  color: #333333;
  font: normal 500 16px / normal "PingFang SC", "Hiragino Sans GB",
    "Noto Sans CJK SC", "Source Han Sans SC", "Microsoft YaHei", "SimHei",
    Helvetica, Arial, serif;
  white-space: nowrap;
  display: -ms-flexbox;
  display: flex;
  cursor: pointer;
  margin-left: 32px;
}

.mobile-global-navigation__right-header-menu-item:first-child {
  margin-left: 0px;
}

.mobile-global-navigation__right-header-wrapper {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-left: 24px;
}

.mobile-global-navigation__right-header-menu-item:first-child {
  margin-left: 0px;
}

.mobile-global-navigation__close-btn {
  cursor: pointer;
}
.mobile-global-navigation__search-container--active {
  display: -ms-flexbox;
  display: flex;
}
.mobile-global-navigation__search-container {
  background-color: #f5f5f5;
  height: 56px;
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  padding-left: 32px;
  padding-right: 20px;
  position: relative;
  width: 100%;
  display: none;
}
.mobile-global-navigation__search-container--active {
  display: -ms-flexbox;
  display: flex;
}

.mobile-global-navigation__search-input {
  border: 0px;
  padding-left: 1px;
  color: #151515;
  font: normal 500 16px/24px "PingFang SC", "Hiragino Sans GB",
    "Noto Sans CJK SC", "Source Han Sans SC", "Microsoft YaHei", "SimHei",
    Helvetica, Arial, serif;
  width: 100%;
  background-color: #f5f5f5;
}

.mobile-global-navigation__suggestion-keywords-container {
  position: absolute;
  top: 55px;
  left: 0;
  width: 100%;
}

.mobile-global-navigation__right-menu-list {
  display: none;
  -ms-flex-direction: column;
  flex-direction: column;
}
.mobile-global-navigation__right-menu-list--active {
  display: -ms-flexbox;
  display: flex;
}

.mobile-global-navigation__right-menu-item {
  color: #666;
  font: normal 500 16px/23px "PingFang SC", "Hiragino Sans GB",
    "Noto Sans CJK SC", "Source Han Sans SC", "Microsoft YaHei", "SimHei",
    Helvetica, Arial, serif;
  padding: 24px 0px;
  text-align: left;
}

.mobile-global-navigation__right-menu-item a {
  color: #333;
}

@media screen and (max-width: 1200px) {
  .header_desktop-container {
    display: none;
  }

  .header_logo {
    width: 100%;
    max-width: 162px;
    height: auto;
    display: inline-block;
    vertical-align: bottom;
  }
}

@media screen and (max-width: 1440px) {
  .header_sub-menu-list1 .header_sub-menu-item:nth-last-child(2) {
    padding-right: 200px;
  }
}
</style>
